import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class Square9ApiModule {}
